// extracted by mini-css-extract-plugin
module.exports = {"root":"_3cardsrow-module--root--2SNg-","cards":"_3cardsrow-module--cards--2jUX0","card":"_3cardsrow-module--card--2mNSI"};